const platform = 'web';
const buildNumber = undefined;
const appVersion = undefined;
const brandName = undefined;

export const platformInfo = {
    platform,
    buildNumber,
    appVersion,
    brandName,
};
